import React from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Input, LegacyForm, Space, Typography } from "@payping/web-components";
import { DashboardChecksTypeEnum } from "@payping/api";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useHandleNavigationURL, useSaveToRedux } from "../../utils";
import { selectAtom } from "jotai/utils";
import { settingsBusinessAtom } from "@/mobile/Settings/state";
import { useAtom } from "jotai";
import { Trans } from "@payping/utils/localeUtils";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditOfficialBusinessSabtNumber: React.FC = () => {
  const { t } = useAppTranslation();
  const [form] = LegacyForm.useForm();
  const checks = useAppSelector((state) => state.user.checks);
  const isSabtDisabled = checks?.businessRegistrationStatus === DashboardChecksTypeEnum.Confirmed;
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const sabtNumberApi = useAppSelector((state) => state.user.businessInfo?.sabtNumber);

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        placement={"bottom"}
        open={true}
        height={"100%"}
        title={`${t("edit")} / ${t("settings.business.sabtNumber")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Space orientation={"vertical"}>
          <LegacyForm
            onFinish={({ sabtNumber }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL:
                  DashboardRoutes.register.mEditBusiness.officialBusinessRegistrationDate.url,
                nextUrlForEdit: DashboardRoutes.settings.mEditBusiness.officialBusinessRegistrationDate.url,
                fieldName: "sabtNumber",
                fieldValue: sabtNumber,
                setIsDrawerOpen: () => {},
              })
            }
            form={form}
            initialValues={{ sabtNumber: mobileFormEditState.sabtNumber ?? sabtNumberApi }}
          >
            <LegacyForm.Item label={t("profile.sabtNumber")} name={"sabtNumber"} rules={[{ required: true }]}>
              <Input disabled={!form.getFieldValue("sabtNumber") ? false : isSabtDisabled} />
            </LegacyForm.Item>
          </LegacyForm>
          <Typography.Text className="tw:whitespace-pre-line" type={"secondary"}>
            <Trans
              i18nKey={"mobileEditPersonal.nameDesc"}
              components={[
                <Typography.Link
                  key={0}
                  href={"https://irsherkat.ssaa.ir/Design/SearchCompanyPublicInfo.aspx"}
                  target="_blank"
                />,
              ]}
            />
          </Typography.Text>
        </Space>
      </Drawer>
      <EditActionButtons onAccept={form.submit} acceptText={t("next")} />
    </>
  );
};

export default MobileEditOfficialBusinessSabtNumber;
